import { cloudApi } from './http.js'
const path = (tenant, project) => `/api/tenants/${encodeURIComponent(tenant)}/projects/${encodeURIComponent(project)}`
const query = filters => new URLSearchParams(Object.entries(filters).filter(([, value]) => value !== '' && value != null))

export const dispatchSchedulesApi = Object.freeze({
  list(tenant, project, filters = {}) {
    return cloudApi.get(`${path(tenant, project)}/dispatch-schedules?${query(filters)}`)
  },
  create(tenant, project, body) {
    return cloudApi.post(`${path(tenant, project)}/dispatch-schedules`, body)
  },
  update(tenant, project, id, body) {
    return cloudApi.patch(`${path(tenant, project)}/dispatch-schedules/${encodeURIComponent(id)}`, body)
  },
  occurrences(tenant, project, filters = {}) {
    return cloudApi.get(`${path(tenant, project)}/dispatch-occurrences?${query(filters)}`)
  },
  stopOccurrence(tenant, project, id, body) {
    return cloudApi.post(`${path(tenant, project)}/dispatch-occurrences/${encodeURIComponent(id)}:stop`, body)
  },
})
